import store from '@/store.js';
import Request from './request';
import request_configs from "./request_configs";

async function fetchList(data) {
    request_configs.Headers['access-token'] = localStorage.getItem('accessToken')
    return Request(
        'post',
        request_configs.AdminUrl + 'api/base-announcement/get-base-announcements',
        data,
        false,
        false,
        false,
        request_configs.Headers
    )
}

async function readBaseAnnouncement(data) {
    request_configs.Headers['access-token'] = localStorage.getItem('accessToken')
    return Request(
        'post',
        request_configs.AdminUrl + 'api/base-announcement/read-base-announcement',
        data,
        false,
        false,
        false,
        request_configs.Headers
    )
}

async function getUnreadBaseAnnouncementsCount(data) {
    request_configs.Headers['access-token'] = localStorage.getItem('accessToken')
    const response = await Request(
        'post',
        request_configs.AdminUrl + 'api/base-announcement/get-unread-base-announcements-count',
        data,
        false,
        false,
        false,
        request_configs.Headers
    )
    if (response.data && response.data.status.isOK()) {
        store.commit("unReadNotice", response.data.data);
    }
    return response;
}


export default {
    fetchList,
    readBaseAnnouncement,
    getUnreadBaseAnnouncementsCount,
}
